import React from 'react';
import Filters from './Filters';

const filterSection = ({ label, mode, allFilters, selected, onSelected, error }) => {
  return (
    <div className="inputFieldContainer makeFlex column">
      <label className={`latoBold appendBottom15 font14 ${error ? 'redText' : 'defaultGreyText'}`}>{label}</label>
      <Filters mode={mode} allFilters={allFilters} selected={selected} onSelected={onSelected}/>
    </div>
  );
};

export default filterSection;
